import { render } from "./SingleCard.vue?vue&type=template&id=b9e85470&scoped=true"
import script from "./SingleCard.vue?vue&type=script&lang=js"
export * from "./SingleCard.vue?vue&type=script&lang=js"

import "./SingleCard.vue?vue&type=style&index=0&id=b9e85470&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e85470"]])

export default __exports__